import AppImage from '@/components/ui/AppImage';
 import Icon from'@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = 2026

  const quickLinks = [
    { id: 'footer_home', label: 'Home', href: '/homepage' },
    { id: 'footer_about', label: 'About Us', href: '/about' },
    { id: 'footer_products', label: 'Products', href: '/products' },
    { id: 'footer_faq', label: 'FAQ', href: '/faq' },
    { id: 'footer_contact', label: 'Contact', href: '/contact' },
    { id: 'footer_partnership', label: 'Become a Distributor', href: '/contact#distributor-form' },
  ]

  const socialLinks = [
    { id: 'social_facebook', icon: 'facebook', label: 'Facebook', href: '#' },
    { id: 'social_twitter', icon: 'twitter', label: 'Twitter', href: '#' },
    { id: 'social_instagram', icon: 'instagram', label: 'Instagram', href: '#' },
  ]

  return (
    <footer className="py-8 md:py-12 px-4 md:px-6 border-t border-border bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8 mb-6 md:mb-8">
          {/* Logo Only */}
          <div className="flex items-center justify-center">
            <div className="w-[220px] h-[90px] relative flex items-center justify-center">
              <AppImage
                src="/assets/images/BAF_Website_Logo-1771319612387.png"
                alt="BloomFeeds logo showing company brand identity"
                className="object-contain"
                width={220}
                height={90}
              />
            </div>
          </div>

          {/* Quick Links */}
          <nav className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {quickLinks?.map((link) => (
              <a
                key={link?.id}
                href={link?.href}
                className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
              >
                {link?.label}
              </a>
            ))}
          </nav>

          {/* Social Links */}
          <div className="flex items-center gap-3 md:gap-4">
            {socialLinks?.map((social) => (
              <a
                key={social?.id}
                href={social?.href}
                aria-label={social?.label}
                className="w-10 h-10 rounded-full bg-secondary hover:bg-primary/10 flex items-center justify-center transition-all group"
              >
                <Icon 
                  name={social?.icon === 'facebook' ? 'UserGroupIcon' : social?.icon === 'twitter' ? 'ChatBubbleLeftIcon' : 'CameraIcon'} 
                  size={20} 
                  className="text-muted-foreground group-hover:text-primary transition-colors" 
                />
              </a>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-sm text-muted-foreground">
          <p>© {currentYear} BloomFeeds. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-primary transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}